import Vue from 'vue';
import App from './App.vue';
import router from './router/index.js';
import store from './store';
import animated from 'animate.css';
import lazyload from 'vue-lazyload';
import './components';
import './assets/js/msize.js';
import './assets/scss/icon.scss';
import './assets/scss/style.scss'; // 导入公共样式
import Vconsole from 'vconsole'; //移动端调试工具

import { axGet, axPost } from './api/index';
Vue.prototype.$axPost = axPost;
Vue.prototype.$axGet = axGet;

// if (process.env.NODE_ENV == 'development') {
//   new Vconsole();
// }

Vue.config.productionTip = false;

Vue.use(animated);

// let ispopstate = false
// window.onpopstate = ()=>{
// 	ispopstate = true
// }
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
  // if(ispopstate){
  // 	if(from.meta.parent){
  // 		if(from.path == from.meta.parent){
  // 			ispopstate = false
  // 			next(false)
  // 		}else{
  // 			ispopstate = false
  // 			next(from.meta.parent)
  // 		}
  // 	}
  // }else{
  // 	ispopstate = false
  // 	next()
  // }
});

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount('#app');
